module.exports = __webpack_public_path__ + "assets/img/img248.49a6e458.png";